export const ACTION_TYPE = {
  DIRECT_LINK_INSTALL: 1,
  COLLECT_EMAIL: 2,
  POPUP_LINK: 3
};

export const EXPERIMENT_PAGE_TYPE = {
  APP: 1,
  SEARCH: 2,
  CATEGORY: 3,
  SEARCH_ADS: 4
};

export const ONE_LINK_URL = 'https://engmntqa.onelink.me/';

export const EXPERIMENT_PAGE_TYPE_TEXT = {
  [EXPERIMENT_PAGE_TYPE.APP]: 'product',
  [EXPERIMENT_PAGE_TYPE.SEARCH]: 'search',
  [EXPERIMENT_PAGE_TYPE.CATEGORY]: 'category',
  [EXPERIMENT_PAGE_TYPE.SEARCH_ADS]: 'asa'
};


export const EXPERIMENT_ELEMENT_TYPE = { // NUMBER is BACK-END FIELDS
  SCREENSHOT: 1,
  ICON: 2,
  NAME: 3,
  PRICE: 4,
  IN_APP_PURCHASES: 5,
  DESCRIPTION: 6,
  VIDEO: 7,
  RATING: 8,
  APPLE_WATCH: 9,
  FEATURED_PAGE: 10,
  MULTIVARIATE: 11,
  LAYOUT: 12,
  APP_POSITION: 13,
  FEATURED_BANNER: 14,
  SUBTITLE: 15,
  SHORT_DESCRIPTION: 16
};

export const EXPERIMENT_ELEMENT_TYPE_TEXT = {
  [EXPERIMENT_ELEMENT_TYPE.SCREENSHOT]: 'screenshot',
  [EXPERIMENT_ELEMENT_TYPE.ICON]: 'icon',
  [EXPERIMENT_ELEMENT_TYPE.NAME]: 'name',
  [EXPERIMENT_ELEMENT_TYPE.PRICE]: 'price',
  [EXPERIMENT_ELEMENT_TYPE.IN_APP_PURCHASES]: 'in_app_purchases',
  [EXPERIMENT_ELEMENT_TYPE.DESCRIPTION]: 'description',
  [EXPERIMENT_ELEMENT_TYPE.VIDEO]: 'video',
  [EXPERIMENT_ELEMENT_TYPE.RATING]: 'rating',
  [EXPERIMENT_ELEMENT_TYPE.APPLE_WATCH]: 'apple_watch',
  [EXPERIMENT_ELEMENT_TYPE.FEATURED_PAGE]: 'featured_page',
  [EXPERIMENT_ELEMENT_TYPE.MULTIVARIATE]: 'custom',
  [EXPERIMENT_ELEMENT_TYPE.LAYOUT]: 'layout',
  [EXPERIMENT_ELEMENT_TYPE.APP_POSITION]: 'app_position',
  [EXPERIMENT_ELEMENT_TYPE.FEATURED_BANNER]: 'featured_banner',
  [EXPERIMENT_ELEMENT_TYPE.SUBTITLE]: 'subtitle',
  [EXPERIMENT_ELEMENT_TYPE.SHORT_DESCRIPTION]: 'short_description'
};

export const STORE = {
  GOOGLE_PLAY: 'gplay',
  ITUNES: 'itunes'
};

export const TARGET_TYPE = {
  IPHONE: 1,
  IPAD: 2,
  ANDROID: 3,
  ANDROID_TABLET: 4
};


export const DEVICE_TYPE = {
  MOBILE: 'mobile',
  TABLET: 'tablet',
  DESKTOP: 'desktop',
  OTHER: 'other'
};

export const TARGET_TYPE_DEVICE_TYPE_MAP = {
  [TARGET_TYPE.IPHONE]: DEVICE_TYPE.MOBILE,
  [TARGET_TYPE.IPAD]: DEVICE_TYPE.TABLET,
  [TARGET_TYPE.ANDROID]: DEVICE_TYPE.MOBILE,
  [TARGET_TYPE.ANDROID_TABLET]: DEVICE_TYPE.TABLET
};

export const VIEW_TYPE = {
  SEARCH: 'search',
  CATEGORY: 'category'
};

export const BANNER_TYPE = {
  DESCRIPTION: 'description',
  SCREENSHOTS: 'screenshots',
  NONE: null
};

export const VIDEO_WATCHING_MODE = {
  ACTIVATE: 'activate',
  WATCH: 'watch'
};

export const IPHONE_SCREEN_TYPE = {
  SCREEN_6_5: 'iphone_6_5_inch',
  SCREEN_5_8: 'iphone_5_8_inch',
  SCREEN_5_5: 'iphone_5_5_inch',
  SCREEN_4_7: 'iphone_4_7_inch',
  SCREEN_4_0: 'iphone_4_0_inch'
};

export const IPAD_SCREEN_TYPE = {
  IPAD_12_9: 'ipad_12_9_inch'
};

export const ANDROID_SCREEN_TYPE = {
  PHONE: 'android-phone'
};

export const MODE_PREVIEW = 'preview';

export const ANDROID_TABLET_SIZE = 600;

export const APPSTORE_LINK = 'https://apps.apple.com/us/genre/ios/id36?mt=8';

export const CURRENCIES = {
  USD: '$',
  KPW: '₩',
  KRW: '₩'
};


export const EVENTS_BADGES_TYPE = {
  CHALLENGE: 1,
  COMPETITION: 2,
  LIVE_EVENT: 3,
  MAJOR_UPDATE: 4,
  NEW_SEASON: 5,
  PREMIERE: 6,
  SPECIAL_EVENT: 7
};



// WEBPACK FOOTER //
// ./src/config/constants.js